import worldmap from "../assets/images/worldmap1.png";
import { GameState } from "./GameState";
import Location from "./Location";
import { useContext } from "react";
import MapEntity from "./MapEntity";

const Map = () => {
  const state = useContext(GameState);

  const selectLocation = (id) => {
    if (id === state.selectedLocation) {
      state.setSelectedLocation(-1);
    } else {
      state.setSelectedLocation(id);
    }
  };

  return (
    <div className="map">
      {state.entities.map((entity) => {
        return (
          <MapEntity
            position={entity.position}
            face={entity.face}
            dimension={entity.dimension}
          />
        );
      })}
      {state.locations.map((loc, idx) => {
        return (
          <Location
            id={idx}
            name={loc.name}
            position={loc.position}
            selected={idx === state.selectedLocation}
            selectLocation={() => {
              selectLocation(idx);
            }}
            getMoney={() => {
              return state.locations[idx].money;
            }}
            active={loc.active}
          />
        );
      })}
      <div className="map-container">
        <img
          className="map-img"
          src={worldmap}
          alt=""
          onClick={() => state.setSelectedLocation(-1)}
        />
      </div>
    </div>
  );
};

export default Map;
